module.exports = __webpack_public_path__ + "static/media/Logo.487fbb03.svg";